import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformUser from '@/types/table/platformUser';
import { PlatformUserEntryInfoData } from '@/api/generated/platformUserEntryInfoController';
import { PlatformUserCareerExperienceData } from '@/api/generated/platformUserCareerExperienceController';
import { PlatformUserContactInfoData } from '@/api/generated/platformUserContactInfoController';
import { PlatformUserEduExpData } from '@/api/generated/platformUserEduExpController';
import { PlatformUserEntryInterviewersData } from '@/api/generated/platformUserEntryInterviewersController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformUserData extends PlatformUser {
  platformUserEntryInfo?: PlatformUserEntryInfoData;
  platformUserCareerExperienceList?: PlatformUserCareerExperienceData[];
  platformUserContactInfo?: PlatformUserContactInfoData;
  platformUserEduExpList?: PlatformUserEduExpData[];
  platformUserEntryInterviewersList?: PlatformUserEntryInterviewersData[];
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformUserController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformUserData>>(API_CONTEXT + '/app/platformUser/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformUserData>(API_CONTEXT + '/app/platformUser/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformUser/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformUser/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformUser/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUser/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUser/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUser/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUser/deleteBatch', params, httpOptions);
  }
}
